import { LoadingStatus } from "../../types/types";
import { RootState } from "../../store";

export const selectAdminState = (state: RootState) => state.admin;

export const selectAdminStateErrors = (state: RootState) =>
    selectAdminState(state).errors;

export const selectAdminStateUsers = (state: RootState) =>
    selectAdminState(state).users;

export const selectAdminStateUser = (state: RootState) =>
    selectAdminState(state).user;

export const selectPagesCount = (state: RootState): number =>
    selectAdminState(state).pagesCount;

export const selectTotalElements = (state: RootState): number =>
    selectAdminState(state).totalElements;

export const selectIsPerfumeAdded = (state: RootState): boolean =>
    selectAdminState(state).isPerfumeAdded;

export const selectIsPerfumeEdited = (state: RootState): boolean =>
    selectAdminState(state).isPerfumeEdited;

export const selectIsPerfumeDeleted = (state: RootState): boolean =>
    selectAdminState(state).isPerfumeDeleted;

export const selectIsAdminStateLoading = (state: RootState): boolean =>
    selectAdminState(state).loadingState === LoadingStatus.LOADING;
